/**
 * A viagem do servidor, no formato que `@nv/core` deriva.
 *
 * Uma conversão só, num lugar só. Cada tela fazendo a sua produziria versões
 * diferentes do que é "a viagem" — e foi assim que a Home acabou lendo uma
 * viagem que não era a aberta.
 *
 * As datas chegam como texto do servidor e saem como `CalendarDate` validada:
 * se o servidor mandar algo impossível, a tela prefere não desenhar a desenhar
 * "Invalid Date".
 */

import { calendarDate } from '@nv/core';

import type { TripInput } from '../features/home/model';
import type { ViagemAtual } from './TripContext';

export function tripInputDaViagem(
  viagem: ViagemAtual,
  participantCount: number,
): TripInput | null {
  try {
    return {
      name: viagem.name,
      destination: viagem.primaryDestination,
      startDate: calendarDate(viagem.startDate),
      endDate: calendarDate(viagem.endDate),
      timeZone: viagem.timezone,
      status: viagem.status,
      participantCount,
    };
  } catch {
    return null;
  }
}
